import type { ShouldRevalidateFunctionArgs } from 'react-router';

import { salariesApiFetchJobSynonym } from 'modules/salaries/api/salariesApiFetchJobSynonym';
import { searchGetJobsRoutePath } from 'modules/search/routing/helpers/searchGetJobsRoutePath';
import type { searchJobsRouteReference } from 'modules/search/routing/search.routes';
import type { HorizonLoaderFunctionArgs } from 'routing/types/HorizonLoaderFunctionArgs';

import { SearchJobsPageLoadable } from './SearchJobsPageLoadable';
import { SearchJobsRefinements } from './components/SearchJobsRefinements';

export const handle = {
  searchRefinements: <SearchJobsRefinements />,
  urlByLocale: {
    en: searchGetJobsRoutePath({ lang: 'en' }),
    es: searchGetJobsRoutePath({ lang: 'es' }),
    pt: searchGetJobsRoutePath({ lang: 'pt' }),
  } as const satisfies Record<UserLocale, string>,
  defaultSearchType: 'JOB',
  hideFooterDivider: true,
  showDesktopSearch: true,
  isSearchPage: true,
};

export async function loader({
  request,
}: HorizonLoaderFunctionArgs<typeof searchJobsRouteReference>) {
  try {
    const url = new URL(request.url);

    const synonymId = url.searchParams.get('synonymId');

    const [synonym] = await Promise.all([
      synonymId ? salariesApiFetchJobSynonym(synonymId) : Promise.resolve(),
    ]);

    return { synonym };
  } catch (e) {
    // @TODO: Should we log and/or throw an error?
    return { synonym: null };
  }
}

export default function SearchJobsHorizonRoute() {
  return <SearchJobsPageLoadable />;
}

export function shouldRevalidate({
  currentUrl,
  defaultShouldRevalidate,
  nextUrl,
}: ShouldRevalidateFunctionArgs) {
  if (currentUrl.searchParams.size === nextUrl.searchParams.size) {
    return false;
  }

  return defaultShouldRevalidate;
}
